import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useApi, useWorkspace } from '~/contexts';
import { PageLoader } from '~/routes/public/pages';

const AssistantProfilesContext = React.createContext();

function AssistantProfilesProvider({ children }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const [data, setData] = useState(null);

  const fetchData = useCallback(async () => {
    const { data } = await api.www.workspaces(workspace.id).ai().assistantProfiles().list();
    setData(data);
  }, [api, workspace.id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <AssistantProfilesContext.Provider value={{ profiles: data ?? [], fetchData }}>
      {data === null ? <PageLoader /> : children}
    </AssistantProfilesContext.Provider>
  );
}

function useAssistantProfiles() {
  return useContext(AssistantProfilesContext);
}

export { AssistantProfilesContext, AssistantProfilesProvider, useAssistantProfiles };
